
{
  "familyId": "GET-BREUK-BASIS",
  "questions": [
    {
      "id": "GET-BREUK-BASIS-001",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "multiple_choice",
      "question": "Welke breuk zie je hier? (3 van de 4 delen zijn gekleurd)",
      "context": null,
      "options": ["$\\frac{3}{4}$", "$\\frac{1}{4}$", "$\\frac{4}{3}$", "$\\frac{3}{1}$"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "fraction", "data": {"numerator": 3, "denominator": 4, "label": "3 van de 4 delen", "visualType": "bar", "showEaten": false}}],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Breuk aflezen van een plaatje", "content": "Stap 1: Tel het totaal aantal gelijke stukken → dat is de noemer (onder de streep). Stap 2: Tel de gekleurde stukken → dat is de teller (boven de streep). Hier: 4 stukken totaal, 3 gekleurd = ¾.", "icon": "lightbulb"}}],
      "conceptId": "fraction_visual_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.2,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Je ziet 4 gelijke stukken. Daarvan zijn er 3 gekleurd. Het getal boven de streep (3) zegt hoeveel stukken gekleurd zijn. Het getal onder de streep (4) zegt hoeveel stukken er in totaal zijn. Dus: 3 van de 4 = $\\frac{3}{4}$.",
        "solutionSteps": ["Tel het totaal aantal stukken: 4", "Tel de gekleurde stukken: 3", "Schrijf de breuk: $\\frac{3}{4}$ (3 boven de streep, 4 onder de streep)"],
        "distractorExplanations": {
          "0": "Goed! 4 stukken in totaal en 3 daarvan zijn gekleurd: $\\frac{3}{4}$.",
          "1": "Dit is $\\frac{1}{4}$. Dan zou maar 1 van de 4 stukken gekleurd zijn, maar hier zijn het er 3. Tel de gekleurde stukken opnieuw.",
          "2": "Bij $\\frac{4}{3}$ is het getal boven de streep groter dan het getal onder de streep. Dat betekent meer dan 1 heel, maar op het plaatje zie je minder dan 1 heel.",
          "3": "$\\frac{3}{1}$ betekent 3 hele. Dan zou alles gekleurd zijn (en nog 2 hele extra). Dat past niet bij het plaatje."
        }
      }
    },
    {
      "id": "GET-BREUK-BASIS-002",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "multiple_choice",
      "question": "Wat betekent de teller in een breuk?",
      "context": null,
      "options": ["hoeveel delen je hebt (of hoeveel gekleurd is)", "in hoeveel delen je het geheel verdeelt", "het hele getal", "de som van de delen"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "fraction", "data": {"numerator": 2, "denominator": 5, "label": "2 van de 5 delen", "visualType": "bar", "showEaten": false}}],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Teller en noemer onthouden", "content": "De teller (boven de streep) telt hoeveel stukken je hebt. De noemer (onder de streep) noemt hoeveel gelijke stukken er in totaal zijn. Ezelsbruggetje: Teller = Tellen (hoeveel heb je?), Noemer = Noemen (hoeveel zijn er?).", "icon": "lightbulb"}}],
      "conceptId": "fraction_numerator_meaning",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "In een breuk staat het getal boven de streep. Dat getal vertelt hoeveel stukken je hebt (of hoeveel er gekleurd zijn). Bij $\\frac{2}{5}$ heb je 2 van de 5 stukken.",
        "solutionSteps": ["Het getal boven de streep zegt hoeveel stukken je hebt", "Bij $\\frac{2}{5}$: het getal boven de streep is 2 → je hebt 2 stukken"],
        "distractorExplanations": {
          "0": "Goed! Het getal boven de streep vertelt hoeveel stukken je hebt.",
          "1": "Je hebt het getal boven de streep en het getal onder de streep door elkaar gehaald. Het getal onder de streep zegt in hoeveel gelijke stukken je het geheel verdeelt. Het getal boven de streep zegt hoeveel stukken je hebt.",
          "2": "Het getal boven de streep is niet 'het hele getal'. Het zegt hoeveel stukken je hebt. Bij $\\frac{2}{5}$ heb je 2 stukken.",
          "3": "Het getal boven de streep is gewoon het aantal stukken dat je hebt, niet een som. Bij $\\frac{2}{5}$ heb je 2 stukken — je telt ze niet bij elkaar op."
        }
      }
    },
    {
      "id": "GET-BREUK-BASIS-003",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "multiple_choice",
      "question": "Wat betekent de noemer in een breuk?",
      "context": null,
      "options": ["in hoeveel gelijke delen je het geheel verdeelt", "hoeveel delen je hebt (of hoeveel gekleurd is)", "het hele getal", "de som van de delen"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "fraction", "data": {"numerator": 3, "denominator": 8, "label": "3 van de 8 delen", "visualType": "bar", "showEaten": false}}],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Teller en noemer onthouden", "content": "De noemer (onder de streep) noemt hoeveel gelijke stukken er in totaal zijn. De teller (boven de streep) telt hoeveel stukken je hebt. Ezelsbruggetje: Noemer = Noemen (het totaal), Teller = Tellen (wat je hebt).", "icon": "lightbulb"}}],
      "conceptId": "fraction_denominator_meaning",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.7,
      "feedback": {
        "explanationText": "In een breuk staat het getal onder de streep. Dat getal vertelt in hoeveel gelijke stukken het geheel is verdeeld. Bij $\\frac{3}{8}$ is het geheel in 8 gelijke stukken verdeeld.",
        "solutionSteps": ["Het getal onder de streep zegt in hoeveel gelijke stukken het geheel is verdeeld", "Bij $\\frac{3}{8}$: het getal onder de streep is 8 → het geheel is in 8 gelijke stukken verdeeld"],
        "distractorExplanations": {
          "0": "Goed! Het getal onder de streep vertelt in hoeveel gelijke stukken het geheel is verdeeld.",
          "1": "Je hebt het getal onder de streep en het getal boven de streep door elkaar gehaald. Het getal boven de streep zegt hoeveel stukken je hebt. Het getal onder de streep zegt in hoeveel gelijke stukken het geheel is verdeeld.",
          "2": "Het getal onder de streep is niet 'het hele getal'. Het zegt in hoeveel gelijke stukken je het geheel verdeelt. Bij $\\frac{3}{8}$ zijn er 8 gelijke stukken.",
          "3": "Het getal onder de streep is het totaal aantal gelijke stukken, niet een som. Bij $\\frac{3}{8}$ zijn er 8 gelijke stukken in totaal."
        }
      }
    },
    {
      "id": "GET-BREUK-BASIS-004",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "multiple_choice",
      "question": "Welke breuk is groter: $\\frac{1}{2}$ of $\\frac{1}{4}$?",
      "context": null,
      "options": ["$\\frac{1}{2}$", "$\\frac{1}{4}$", "ze zijn even groot", "dat kun je niet zeggen"],
      "correctAnswer": 0,
      "stimulusAids": [
        {"type": "fraction", "data": {"numerator": 1, "denominator": 2, "label": "$\\frac{1}{2}$", "visualType": "bar", "showEaten": false}},
        {"type": "fraction", "data": {"numerator": 1, "denominator": 4, "label": "$\\frac{1}{4}$", "visualType": "bar", "showEaten": false}}
      ],
      "supportAids": [
        {"type": "fraction", "showWhen": "wrong", "data": {"numerator": 1, "denominator": 2, "label": "Een halve is groter dan een kwart", "visualType": "bar", "showEaten": false}},
        {"type": "fraction", "showWhen": "wrong", "data": {"numerator": 1, "denominator": 4, "label": "Een kwart is kleiner", "visualType": "bar", "showEaten": false}}
      ],
      "conceptId": "fraction_compare_unit",
      "variantIndex": 4,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Vergelijk de getallen onder de streep: $\\frac{1}{2}$ heeft 2 stukken, $\\frac{1}{4}$ heeft 4 stukken. Meer stukken = elk stuk is kleiner. Dus: $\\frac{1}{2}$ > $\\frac{1}{4}$ — minder stukken = elk stuk groter.",
        "solutionSteps": ["Kijk naar het getal onder de streep: 2 of 4", "Meer stukken = elk stuk kleiner", "$\\frac{1}{2}$ heeft 2 stukken, $\\frac{1}{4}$ heeft 4 stukken", "Dus $\\frac{1}{2}$ > $\\frac{1}{4}$"],
        "distractorExplanations": {
          "0": "Goed! 1 van de 2 stukken is groter dan 1 van de 4 stukken.",
          "1": "Je dacht waarschijnlijk dat meer stukken = groter. Maar meer stukken betekent dat elk stuk kleiner is. Een kwart is kleiner dan een half. Onthoud: groter getal onder de streep = kleinere stukken.",
          "2": "Je dacht waarschijnlijk dat ze even groot zijn. Maar teken het: een halve taart is duidelijk groter dan een kwart taart. Onthoud: vergelijk door te tekenen.",
          "3": "Je dacht waarschijnlijk dat je het niet kunt vergelijken. Maar je kunt het wél: teken hetzelfde geheel in 2 en in 4 stukken. Dan zie je meteen dat $\\frac{1}{2}$ groter is. Onthoud: breuken kun je altijd vergelijken."
        }
      }
    },
    {
      "id": "GET-BREUK-BASIS-005",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "multiple_choice",
      "question": "Een pizzabakker snijdt een pizza in 6 gelijke stukken. Je eet er 2. Welke breuk van de pizza heb je gegeten?",
      "options": ["$\\frac{2}{6}$", "$\\frac{6}{2}$", "$\\frac{4}{6}$", "$\\frac{2}{4}$"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "fraction", "data": {"numerator": 2, "denominator": 6, "label": "2 van de 6 stukken gegeten", "visualType": "circle", "showEaten": true}}],
      "supportAids": [{"type": "fraction", "showWhen": "wrong", "data": {"numerator": 2, "denominator": 6, "label": "2 stukken gegeten van 6 gelijke stukken", "visualType": "circle", "showEaten": true}}],
      "conceptId": "fraction_context_pizza",
      "variantIndex": 5,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De pizzabakker sneed de pizza in 6 gelijke stukken. Je at er 2. Het getal boven de streep (2) zegt hoeveel stukken je hebt gegeten. Het getal onder de streep (6) zegt hoeveel stukken er in totaal waren. Dus: $\\frac{2}{6}$.",
        "solutionSteps": ["Tel het totaal aantal stukken: 6", "Tel de gegeten stukken: 2", "Schrijf de breuk: $\\frac{2}{6}$ (gegeten boven de streep, totaal onder de streep)"],
        "distractorExplanations": {
          "0": "Goed! 2 gegeten van 6 totaal = $\\frac{2}{6}$.",
          "1": "Je dacht waarschijnlijk dat het totaal boven de streep komt. Maar het getal boven de streep zegt hoeveel je hebt (2 gegeten), het getal onder de streep zegt het totaal (6 stukken). Onthoud: gegeten boven, totaal onder.",
          "2": "Je dacht waarschijnlijk dat je de overgebleven stukken telt. Maar de vraag vraagt hoeveel je hebt gegeten (2), niet hoeveel er over zijn (4). Onthoud: lees goed wat de vraag vraagt.",
          "3": "Je dacht waarschijnlijk dat er 4 stukken in totaal zijn. Maar de pizza is in 6 stukken gesneden, niet 4. Onthoud: tel het totaal aantal stukken goed."
        }
      }
    },
    {
      "id": "GET-BREUK-BASIS-006",
      "familyId": "GET-BREUK-BASIS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_basis_visueel",
      "questionType": "matching",
      "question": "Koppel elke breuk aan de juiste beschrijving.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "$\\frac{1}{2}$", "right": "De helft is gekleurd" },
          { "left": "$\\frac{3}{4}$", "right": "Drie van de vier stukken" },
          { "left": "$\\frac{1}{3}$", "right": "Eén van de drie stukken" },
          { "left": "$\\frac{2}{5}$", "right": "Twee van de vijf stukken" }
        ]
      },
      "stimulusAids": [
        {"type": "fraction", "data": {"numerator": 1, "denominator": 2, "label": "$\\frac{1}{2}$", "visualType": "bar", "showEaten": false}},
        {"type": "fraction", "data": {"numerator": 3, "denominator": 4, "label": "$\\frac{3}{4}$", "visualType": "bar", "showEaten": false}},
        {"type": "fraction", "data": {"numerator": 1, "denominator": 3, "label": "$\\frac{1}{3}$", "visualType": "bar", "showEaten": false}},
        {"type": "fraction", "data": {"numerator": 2, "denominator": 5, "label": "$\\frac{2}{5}$", "visualType": "bar", "showEaten": false}}
      ],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Breuk lezen als woorden", "content": "Lees een breuk als: [teller] van de [noemer] stukken. Bijvoorbeeld: ¾ = 3 van de 4 stukken. ½ = 1 van de 2 stukken (= de helft). ⅓ = 1 van de 3 stukken.", "icon": "lightbulb"}}],
      "conceptId": "fraction_matching_description",
      "variantIndex": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Lees elke breuk als woorden: het getal boven de streep zegt hoeveel stukken, het getal onder de streep zegt het totaal. ½ = de helft (1 van 2). ¾ = drie van de vier. ⅓ = één van de drie. ⅖ = twee van de vijf.",
        "solutionSteps": ["Lees elke breuk: teller = hoeveel stukken, noemer = totaal stukken", "½ → de helft is gekleurd", "¾ → drie van de vier stukken", "⅓ → één van de drie stukken", "⅖ → twee van de vijf stukken"]
      }
    }
  ]
}
